import { Navigate, useParams } from 'react-router';

/**
 * Opens an invoice from its own address, `/invoices/:id`, which is where a link to an invoice
 * points.
 *
 * The invoices screen keeps the open invoice in its query string so that opening one from the list
 * is not a change of page. This hands the id over to it, replacing the address rather than adding
 * to the history, so Back leaves the invoice instead of bouncing off this redirect.
 *
 * @returns a redirect to the invoices screen with the invoice open
 */
export function InvoiceDeepLink(): React.JSX.Element {
  const { id = '' } = useParams();
  return (
    <Navigate
      replace
      to={{ pathname: '/invoices', search: `?invoice=${encodeURIComponent(id)}` }}
    />
  );
}
